import { EvolveProductTypeKey } from '../apis/sherpath-app-facade-service/sherpath-app-facade-service.dtos';

export const COURSEWARE_STORAGE = 'COURSEWARE_STORAGE';

export enum STORAGE_KEY {
  COLLAPSED_FOLDER_MAP = 'COLLAPSED_FOLDER_MAP'
}

export enum EbookPageRangeSeparators {
  CHUNK_SEPARATOR = ',',
  RANGE_SEPARATOR = '-',
}

export const standaloneProducts = [
  EvolveProductTypeKey.SIMULATION_SIM_CHART_NG,
  EvolveProductTypeKey.ELSEVIER_ASSESSMENT_BUILDER,
  EvolveProductTypeKey.CLINICALSKILLS_IA,
  EvolveProductTypeKey.SIMULATION_SLS_IA,
  EvolveProductTypeKey.SIMULATION_SLS_AC,
  EvolveProductTypeKey.HESI_SAFEMED_IA,
  EvolveProductTypeKey.MED_ED
];
